import React from "react"
import { Box, Typography } from "@mui/material"
import { IconSeeker } from "@ui-seeker/core"


export default function ShowDetails({ onClick=null }) {
    const styles = {
        cursor: "pointer",
        display: "flex",
        marginTop: "0.6rem",
        columnGap: "3px",
        padding: "0.3rem",
        width: "max-content",
    }

    return <Box data-tour-trigger onClick={onClick} sx={styles}>
        <IconSeeker icon="circle-info" tooltip="View details" />
        <Typography variant="body2" sx={{ display: "inline", fontSize: "0.8rem" }}>
            Show details
        </Typography>
    </Box>
}